import script from "./UnionSchool.vue?vue&type=script&setup=true&lang=js"
export * from "./UnionSchool.vue?vue&type=script&setup=true&lang=js"

import "./UnionSchool.vue?vue&type=style&index=0&id=2612b876&lang=scss&scoped=true"

import exportComponent from "E:\\Projects\\big-screen\\ori\\nnu-data-viewer-1204\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2612b876"]])

export default __exports__